<template>
    <div class="ah-page voucher-print-page">
        <div class="page-header" />
        <div class="print-controls">
            <div class="print-options">
                <el-checkbox v-model="showSignature">顯示簽章欄位</el-checkbox>
            </div>
            <div class="print-actions">
                <el-button type="info" @click="onBack">返回</el-button>
                <el-button type="primary" @click="onPrint">列印</el-button>
            </div>
        </div>
        <div v-if="voucherDatas.length" class="preview" :class="{ multiple: !oneVoucherPerPaper, 'one-page ': oneVoucherPerPaper }">
            <div v-for="voucher in voucherDatas" :key="`${voucher.vono}${voucher.status}`" >
                <div class="print-checkbox">
                    <el-checkbox v-model="voucher.enablePrint" />
                </div>
                <VoucherCard :queryType="voucher.transactionType" :accountTypeSno="voucher.sno" :voucherData="voucher" :showSignature="showSignature" :class="{ disableprint: !voucher.enablePrint}" />
            </div>
        </div>
        <div v-else class="preview">
            <VoucherCard ref="VoucherCard" :queryType="voucherData.transactionType" :accountTypeSno="voucherData.sno" :voucherData="voucherData" :showSignature="showSignature" is-dialog />
        </div>
    </div>
</template>
<script>
import VoucherCard from '@/components/dashboard/Accounting/AccountingSummary/ui/VoucherCard.vue';

export default {
    name: 'VoucherPrintPage',
    components: { VoucherCard },
    data() {
        return {
            isLoading: false,
            oneVoucherPerPaper: false,
            showSignature: false,
            voucherData: {
                accountItems: [],
                dat: null,
                cnl: false,
                cny: 'TWD',
                mem: null,
                sno: null,
                unT_NBR: null,
                unt: null,
                upD_USR: null,
                vono: null,
                voucherType: null,
                isEditing: false,
            },
            voucherDatas: [],
        };
    },
    mounted() {
        const { vono, UNT_NBR } = this.$route.params;
        if (vono) this.getVoucher(vono);
        else if (UNT_NBR) this.getVouchers(UNT_NBR);
    },
    methods: {
        async getVoucher(vono) {
            try {
                const resp = await this.$api({
                    url: '/AccountingSummaryPage/GetVoucher',
                    params: { vono },
                    method: 'GET',
                });

                this.voucherData = resp.data.item;
                this.$nextTick(() => {
                    this.$refs.VoucherCard.updateFormData();
                });
            } catch (e) {
                console.log(e);
            }
        },
        async getVouchers(UNT_NBR) {
            try {
                const resp = await this.$api({
                    url: '/AccountingSummaryPage/GetVouchers',
                    params: { UNT_NBR },
                    method: 'GET',
                });

                this.voucherDatas = resp.data.items.reverse();
                // 把 this.voucherDatas 裡的每個項目都增加屬性 enablePrint
                this.voucherDatas = this.voucherDatas.map((voucher) => {
                    const newVoucher = { ...voucher, enablePrint: true };
                    return newVoucher;
                });
            } catch (e) {
                console.log(e);
            }
        },
        onBack() {
            this.$router.go(-1);
        },
        onPrint() {
            window.print();
        },
    },
};
</script>
<style lang="scss">
@page {
    size: Auto;
    orphans: 4;
    margin: 1cm 0cm 0cm 0cm;
    widows: 2;
}

.voucher-print-page {
    &.ah-page {
        padding: 0;
    }
    .print-controls {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 16px;
        margin: 20px;
        .print-options {
            display: flex;
            align-items: center;
            gap: 12px;
        }
        .print-actions {
            display: flex;
            gap: 8px;
        }
        @media print {
            display: none;
        }
    }
    .page-header {
        @media print {
            display: none;
        }
    }

    .print-checkbox {
        position: relative;
        top: 60px;
        left: 40px;
    }

    .voucher-card {
        &.disableprint {
            opacity: 0.5;
        }
    }


    .preview {
        position: relative;
        width: 900px;
        margin: 0 auto;

        @media print {
            position: relative;
            padding: 0 1cm;
            width: 100%;
            .voucher-table {
                min-height: 300px;
                > tbody td {
                    &.setting,
                    &.content,
                    &.crd-amt,
                    &.deb-amt {
                        height: 30px;
                    }
                }
            }
            .print-checkbox {
                display: none;
            }
            .voucher-card {
                box-shadow: none !important;
                margin: 0;
                border: 0;
                break-inside: avoid;

                &.disableprint {
                    display: none;
                    opacity: 1;
                }
            }
            &.one-page .voucher-card {
                break-inside: unset;
                page-break-after: always !important;
            }
        }
    }
}
</style>
